<p-button
  [type]="type"
  class="mu-button {{ clazz }}"
  [label]="label"
  [icon]="calculateIcon"
  [iconPos]="iconPos"
  [disabled]="disabled"
  (onClick)="eventClick()"
>
  <app-loading [showLoading]="showLoading" *ngIf="showLoading" type="icon"></app-loading>
  <ng-content></ng-content>
</p-button>
